export default function ajax (state = {}, action) {
  const { type, data } = action;
  const matches = type.match(/^AJAX\/(.+)\/(.+)$/);
  if (!matches) {
    return state;
  }
  const [_, status, k] = matches;
  return {
    ...state,
    [k]: status === 'FAILED' ? null : data,
  }
}
